<template>
    <div>
      <vs-table search :data="posSettings">
        <template slot="header">
          <h3>
            Pos Ayarları
          </h3>
        </template>
        <template slot="thead">
          <vs-th class="w-6/12" sort-key="branchName">
            Şube
          </vs-th>
          <vs-th class="w-1/12" sort-key="enabled">
            Durum
          </vs-th>
          <vs-th class="w-6/12" sort-key="modified">
            Değişiklik Tarihi
          </vs-th>
        </template>
  
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].branchName">
              {{data[indextr].branchName}}
            </vs-td>
  
            <vs-td :data="data[indextr].enabled" vs-align="center" >
                <vs-switch class="ml-2" v-model="data[indextr].enabled" @click="switchChanged(data[indextr])">
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
            </vs-td>
  
            <vs-td :data="data[indextr].modified">
              {{data[indextr].modifiedString}}
            </vs-td>
          </vs-tr>
        </template>
  
  
      </vs-table>
    </div>
  </template>
  
  <script>
  import { getAllPosSettings, setPosStatus } from "@/api/AppSettings";
  export default {
    data:()=>({
      posSettings:[
        
      ]
    }),
    created: async function () {
        this.posSettings = (await getAllPosSettings()).data;
    },
    methods:{
        switchChanged: async function (tr) {
            setPosStatus(tr.branchId, !tr.enabled)
            .then((res) => {
              if (res && res.status === 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Pos Cihaz Ayarları Güncellendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Pos Cihaz Ayarları Güncellenemedi !",
                });
              }
            })
            .catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
        }
    }
  }
  </script>